/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { AodRuleInGetManyDto } from "./AodRuleInGetManyDto";

export const AodRunInGetManyDtoTypeEnum = {
    EOW: "EOW",
    ORDER_END: "ORDER_END",
    MANUAL: "MANUAL"
} as const;

export type AodRunInGetManyDtoTypeEnumKey = (typeof AodRunInGetManyDtoTypeEnum)[keyof typeof AodRunInGetManyDtoTypeEnum];

export const AodRunInGetManyDtoStatusEnum = {
    WAITING: "WAITING",
    IN_PROGRESS: "IN_PROGRESS",
    COMPLETED_WITH_EXPORT: "COMPLETED_WITH_EXPORT",
    COMPLETED_WITHOUT_EXPORT: "COMPLETED_WITHOUT_EXPORT",
    WAITING_FOR_REPROCESS: "WAITING_FOR_REPROCESS",
    FAILED: "FAILED"
} as const;

export type AodRunInGetManyDtoStatusEnumKey = (typeof AodRunInGetManyDtoStatusEnum)[keyof typeof AodRunInGetManyDtoStatusEnum];

export const AodRunInGetManyDtoUserStatusEnum = {
    ACCEPTED: "ACCEPTED",
    REFRESHED: "REFRESHED",
    REPROCESSED: "REPROCESSED"
} as const;

export type AodRunInGetManyDtoUserStatusEnumKey = (typeof AodRunInGetManyDtoUserStatusEnum)[keyof typeof AodRunInGetManyDtoUserStatusEnum];

export type AodRunInGetManyDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    clientId: string;
    /**
     * @type string | undefined
    */
    name?: string;
    /**
     * @type string | undefined, date-time
    */
    scheduledDatetime?: string;
    /**
     * @type string
    */
    type: AodRunInGetManyDtoTypeEnumKey;
    /**
     * @type string
    */
    status: AodRunInGetManyDtoStatusEnumKey;
    /**
     * @type string
    */
    userStatus: AodRunInGetManyDtoUserStatusEnumKey;
    /**
     * @type string | undefined
    */
    reportId?: string;
    /**
     * @type string
    */
    order: string;
    /**
     * @type string | undefined
    */
    interval?: string;
    /**
     * @description Number of times this run was executed (processed by ProcessAodRunJob).
     * @type number
    */
    executionCount: number;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string, date-time
    */
    updatedAt: string;
    /**
     * @type boolean
    */
    isPending: boolean;
    /**
     * @type number | undefined
    */
    efficiency?: number;
    /**
     * @type object
    */
    rule: AodRuleInGetManyDto;
};